// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../engines/components/BaseComponent";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import { TaskKind } from "../../../define/TaskKind";
import { BUNDLE_SMALL_NAME, getOneBundleByInstant } from "../../BundleResourceConfig";
import NormalGameManager from "../../manager/NormalGameManager";
import TaskLayer from "./TaskLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskItem extends BaseComponent {

	@property({ type: cc.Label, displayName:'' })
	labelDesc: cc.Label = null;

	@property({ type: cc.Label, displayName:'' })
	labelTitle: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeFinish: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeUnderway: cc.Node = null;

	@property({ type: cc.Sprite, displayName:'' })
	itemIcon: cc.Sprite = null;
    
    private _parent: TaskLayer = null;

    private taskId: string = null;
    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.initUI();
    }

    setData(
        _parent: TaskLayer
        , taskId: string
    ) {
        this.taskId = taskId;
        this._parent = _parent;

        if (this.isInit()) {
            this.initUI();
        }
    }

    initUI() {
        let gameData = NormalGameManager._instance.getGameData();
        let taskData = gameData.taskDataMap[this.taskId];
        if (!taskData) {
            console.error(`未找到taskData数据 taskId = ${this.taskId}`);
        }

        let csvInfo = CsvDataManage.instance.getCsvDataItem(CsvFileKind.CsvFile.TASK_LIST, taskData.id);
        if (!csvInfo) {
            console.error(`未找到TASK_LIST数据 id = ${taskData.id}`);
        }

        this.labelTitle.string = csvInfo.title;
        this.labelDesc.string = csvInfo.desc;

        let bUnderway = taskData.taskState == TaskKind.TaskState.UNDERWAY;
        this.nodeFinish.active = !bUnderway;
    	this.nodeUnderway.active = bUnderway;
     
        this.itemIcon.node.active = false;
        let path = "res/taskicon/" + csvInfo.icon;
        getOneBundleByInstant(BUNDLE_SMALL_NAME.taskBundle).load(path, cc.SpriteFrame
            , (err,imgs:cc.SpriteFrame)=>
            {
                if(err){
                    console.log(err);
                }else{
                    this.itemIcon.node.active = true;
                    this.itemIcon.spriteFrame = imgs;
                }
            }
        );
    }

    // update (dt) {}
}
